import { navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { useCallback } from "react"

import { marketingClient } from "@trueskin-web/apis"
import { Button } from "@trueskin-web/components"
import { Routes, Trans } from "@trueskin-web/translations"

import Card from "./card"

const ChoosePlan = () => {
  const handleClick = useCallback(() => {
    marketingClient.trackEvent({
      name: marketingClient.EVENT_TYPES_ENUM
        .WELCOME_BACK_PAGE_PLAN_SELECTION_CTA_CLICKED,
    })

    navigate(Routes.App.Start.ChoosePlan.url)
  }, [])

  return (
    <Card
      title={
        <div
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div sx={{ maxWidth: "80%" }}>
            <Trans i18nKey="Start.WelcomeBack.Steps.ChoosePlan.title" />
          </div>
          <StaticImage
            src="./images/box_3x.webp"
            alt=""
            width={75}
            sx={{ flexShrink: 0 }}
          />
        </div>
      }
      status="current"
      dataTestId="wb-steps-choose-plan"
    >
      <Button
        rounded
        isFullWidth
        onClick={handleClick}
        sx={{ mt: 1 }}
        data-testid="wb-steps-choose-plan-button"
      >
        <Trans i18nKey="Start.WelcomeBack.Steps.ChoosePlan.buttonText" />
      </Button>
    </Card>
  )
}

export default ChoosePlan
